import React from 'react';

const Frame = ({ className }) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="12" height="12" stroke="white"/>
      <rect width="3" height="3" fill="white"/>
      <rect y="10" width="3" height="3" fill="white"/>
      <rect x="10" width="3" height="3" fill="white"/>
      <rect x="10" y="10" width="3" height="3" fill="white"/>
    </svg>
  )
}

export default Frame;